import { render, staticRenderFns } from "./video-review.vue?vue&type=template&id=9b9f12f4&"
import script from "./video-review.vue?vue&type=script&lang=js&"
export * from "./video-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports